// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"dbd4aa3c","110":"ebe9c3d8","140":"94a066fc","422":"d780d36b","453":"c9161952","619":"39d7b853","624":"490e8f1d","756":"69e16877","784":"a805402d","841":"833da9fc"}[chunkId] + ".chunk.js";
};